import React, { useState } from 'react'
import { Okato } from '../types'

const PurchaseItemsPopupOkved2Search: React.FC<{
    item: any
    theme: string
    onSelected: (value: Okato) => void
}> = ({ item, onSelected, theme }) => {
    return (
        <div>
            <div className="flex flex-row w-full justify-start text-center">
                {/* Отступ для вложенности */}
                <div
                    className={`flex flex-row w-full gap-1 mx-1 text-[11px] rounded cursor-pointer text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#2A282B] hover:bg-[#FFFFFF] dark:hover:bg-[#373538]`}
                    onDoubleClick={() => onSelected(item)}
                >
                    <div className="flex flex-row w-full items-center justify-center gap-2">
                        <div className="flex flex-col w-8 justify-center items-center text-center"></div>
                        <div className="flex w-16 text-left justify-left items-center pl-1 ">
                            {item.code}
                        </div>
                        <div className="flex flex-1 items-center justify-left text-left px-2 py-2  ">
                            {item.name}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PurchaseItemsPopupOkved2Search
